var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';

import { PermissionType } from "../../../shared/types/permissionSchema";
import { NeedAuthorization } from "../../Auth";
import { MemberListItemInfo } from "./MemberListItemInfo";
import { MemberListItemPermission } from "./MemberListItemPermission";






const notShowPublicToCollab = (member, children) =>
member.type === PermissionType.PUBLIC ? /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, children) :

children;


export const MembersList = ({ members, onChange }) => {
  const onChangeHandler = (index) => (value) => {
    const newMembers = [...members];
    newMembers[index] = value;
    onChange(newMembers);
  };

  const onDeleteHandler = (value) => {
    onChange(members.filter((m) => m !== value));
  };

  return (/*#__PURE__*/
    _jsx("table", { className: "members-list" }, void 0, /*#__PURE__*/
    _jsx("tbody", {}, void 0,
    members.map((member, index) => /*#__PURE__*/
    _jsx("tr", {}, `${member.type}-${member.refId}`, /*#__PURE__*/
    _jsx("td", {}, void 0, /*#__PURE__*/
    _jsx(MemberListItemInfo, { value: member })
    ), /*#__PURE__*/
    _jsx("td", {}, void 0,
    notShowPublicToCollab(
      member, /*#__PURE__*/
      _jsx(MemberListItemPermission, {
        value: member,
        onChange: onChangeHandler(index),
        onDelete: onDeleteHandler,
        disabled: !member.refId }
      )
    )
    )
    )
    )
    )
    ));

};